module.exports = __webpack_public_path__ + "static/media/scholarship-1.4032478e.jpg";